// src/pages/HomePage.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import HeroSection from '../components/HeroSection';
import ProductsSection from '../components/ProductsSection';
import AboutSection from '../components/AboutSection';
import ContactSection from '../components/ContactSection';
import SEO from '../components/SEO';
import { homepageStructuredData, siteMeta } from '../seo/siteMeta';

const MainContent = styled.main`
  flex: 1;
`;

const HomePage = () => {
  const location = useLocation();
  const seo = siteMeta.routeSeo.home;

  useEffect(() => {
    // Manejar scroll automático cuando hay un hash en la URL
    if (location.hash) {
      // Remover el # del hash
      const sectionId = location.hash.substring(1);

      // Pequeño delay para asegurar que el DOM esté completamente cargado
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Si no hay hash, scroll al top
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        path={seo.path}
        structuredData={homepageStructuredData}
      />
      <MainContent>
        <HeroSection />
        <ProductsSection />
        <AboutSection />
        <ContactSection />
      </MainContent>
    </>
  );
};

export default HomePage;
